/**
 * Outcome of a Dialog `onOk` / Form `onSave` handler. Returning
 * `DialogResult.KeepOpen` leaves the dialog open so the user can correct an
 * error and retry; returning `DialogResult.Close` — or simply falling through
 * with no return — closes it. Replaces the older `void | false` contract, where
 * "fall through = success" was invisible at the call site.
 */
export const DialogResult = {
  Close: "close",
  KeepOpen: "keep-open",
} as const;
export type DialogResult = (typeof DialogResult)[keyof typeof DialogResult];
